import React, { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
// Part F — line 2 reads "Added {date}" (when the visit entered revQ), not "Created".
const addedStamp = (s) => { const d = s ? new Date(s) : null; return d && !isNaN(d) ? `Added ${d.toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })}` : null; };

const MONO = "'JetBrains Mono',ui-monospace,monospace";
// "Oct 16"; adds the year when the DOS isn't in the current year ("Dec 28, 2025").
export const fmtDosY = (iso) => {
  const d = new Date(String(iso).length === 10 ? `${iso}T00:00:00` : iso);
  if (isNaN(d)) return "—";
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", ...(d.getFullYear() !== new Date().getFullYear() ? { year: "numeric" } : {}) });
};
const fullStamp = (s) => (s ? new Intl.DateTimeFormat(undefined, { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit", timeZoneName: "short" }).format(new Date(s)) : "");

export const DOSV_CSS = `.er-qs{border:1px solid #E9E9EC;transition:border-color .12s,box-shadow .12s}
.er-qs:focus-within{border-color:#5856D6;box-shadow:0 0 0 3px rgba(88,86,214,.15)}
.er-qs-chip{background:#F1F1F4;color:#141412}.er-qs-chip:hover,.er-qs-chip[data-open]{background:#E8E8EC}
.cc-tools .er-qs{height:38px}
.dv-l1{display:flex;align-items:center;min-width:0;gap:2px}.dv-t{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.dv-cp{flex:none;width:20px;height:20px;border-radius:5px;display:grid;place-items:center;color:#6C6C69;opacity:0;background:none;border:0;padding:0;cursor:pointer;transition:opacity .12s,background-color .12s,color .12s}
.dv-l1:hover .dv-cp,.dv-cp:focus-visible{opacity:1}.dv-cp:hover{background:#F1F1F4;color:#141412}.dv-cp.done{opacity:1;color:#248A3D}
@media (hover:none){.dv-cp{opacity:.6}}.dv-vid2{display:none}
@container cctbl (max-width:910px){.dv-sep,.dv-vid1{display:none}.dv-vid2{display:block}}`;

function VisitCopy({ id }) {
  const [done, setDone] = useState(false);
  const go = (e) => { e.stopPropagation(); navigator.clipboard?.writeText(id).then(() => { setDone(true); toast.success("Copied visit ID"); setTimeout(() => setDone(false), 1200); }).catch(() => toast.error("Couldn't copy. Your browser blocked the clipboard.")); };
  return <button type="button" className={`dv-cp ${done ? "done" : ""}`} onClick={go} aria-label={`Copy visit ID ${id}`} title="Copy visit ID" data-testid={`dv-copy-${id}`}>{done ? <Check size={13} strokeWidth={2.5} /> : <Copy size={13} />}</button>;
}

// DOS · Visit cell shared by Encounter review and Claims Queue. Only the visit ID is copyable.
export function DosVisit({ n, tid, noDos }) {
  const cs = addedStamp(n.created_at), vid = n.visit_id || "", full = fullStamp(n.created_at);
  const dos = n.date_of_service ? fmtDosY(n.date_of_service) : "";
  return (
    <div className="min-w-0">
      <div className="dv-l1">
        <span className="dv-t text-[13px]" title={[dos, vid].filter(Boolean).join(" · ")} data-testid={`${tid}-dos-${n.id}`}>
          {dos ? <b className="font-semibold" style={{ color: "#141412" }}>{dos}</b> : noDos}
          {vid ? <span className="dv-vid1"><span className="dv-sep" style={{ color: "#9B9B97" }}> · </span><span style={{ fontFamily: MONO, fontSize: 12, color: "#6C6C69" }} data-testid={`${tid}-visitid-${n.id}`}>{vid}</span></span> : null}
        </span>
        {vid ? <VisitCopy id={vid} /> : null}
      </div>
      {vid ? <div className="dv-vid2 truncate" style={{ fontFamily: MONO, fontSize: 12, color: "#6C6C69" }}>{vid}</div> : null}
      {cs ? <div className="text-[12px] whitespace-nowrap overflow-hidden text-ellipsis mt-0.5" style={{ color: "#6E6E6B" }} title={full ? `Added to revQ ${full}` : cs} data-testid={`${tid}-created-${n.id}`}>{cs}</div> : null}
    </div>
  );
}
